import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {TermPO} from "@/model/product";
import {WriteTermForm} from "@/pages/Term/WriteTerm";

export enum TermEnum {
    GetTermPage = "/term/getTermPage",
    GetTerm = "/term/getTerm",
    CreateTerm = "/term/createTerm",
    UpdateTerm = "/term/updateTerm",
    GetStatKinds = "/term/getStatKinds",
}

export interface TermPageBO extends PaginationBO {
    keyword?: string;
    contractId?: number
}

export interface TermPageVO extends TermPO {
}

export interface TermVO extends TermPO {

}

export interface StatKindVO {
    kind: string;
    amount: number;
    kindId?: number;
    maxSubsidy: number;
}

export interface TermPageBO {
    kindId: number
}

export const useQueryTermPage = () => useMutation({
    mutationFn: (data: TermPageBO) => http.post<BaseVO<PaginationVO<TermPageVO>>>({
        url: `${TermEnum.GetTermPage}`,
        data: data,
    }),
})

export const useCreateTerm = () => useMutation({
    mutationFn: (data: WriteTermForm) => http.put({url: TermEnum.CreateTerm, data}),
})

export const useUpdateTerm = () => useMutation({
    mutationFn: (data: WriteTermForm) => http.post({url: TermEnum.UpdateTerm, data}),
})

export const useQueryTerm = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<TermVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<TermVO>>({
        url: TermEnum.GetTerm,
        params: params
    }),
    enabled
})

export const useQueryStatKinds = () => useQuery({
    queryKey: ['statKinds'], queryFn: () => http.get<BaseVO<StatKindVO[]>>({
        url: TermEnum.GetStatKinds,
    }),
})



